<script setup lang="ts">
import { UiText, UiLink } from '@shopexperts/shared';
</script>

<template>
  <div class="bg-se-dark rounded-md p-3 flex flex-col gap-3 mb-2">
    <div class="flex flex-col gap-1">
      <UiText as="h6" text="Unlock your full potential with shopexperts PRO" class="text-se-white font-semibold" />
      <UiText as="p" variant="h6"
        text="Upgrade to PRO to showcase your full skills and unlock premium features. Locked items won't appear on your profile until you upgrade."
        class="text-se-white/80" />
    </div>
    <UiLink href="#" label="Coming Soon" variant="h6" theme="dark" class="font-semibold underline cursor-not-allowed pointer-events-none" />
  </div>
</template>
